const checkUserLanguage = async (userLanguage: string = 'en') => {
  // Check language cookie
  const currentLanguageFromCookie = getCookie("i18n_redirected");
  // Get the locale switch function
  const switchLocalePath = useSwitchLocalePath();
  let newPath;

  // Convert legacy language codes
  if (!userLanguage && (currentLanguageFromCookie === "ch" || currentLanguageFromCookie === "dk")) {
    if (currentLanguageFromCookie === "ch") {
      deleteCookie("i18n_redirected");
      setCookie("i18n_redirected", "sv");

      newPath = switchLocalePath("sv");
    } else if (currentLanguageFromCookie === "dk") {
      deleteCookie("i18n_redirected");
      setCookie("i18n_redirected", "da");

      newPath = switchLocalePath("da");
    }
  } else if (!userLanguage && currentLanguageFromCookie) {
    return;
  } else if (userLanguage != currentLanguageFromCookie || !currentLanguageFromCookie) {
    // Delete the cookie first and set the new locale
    deleteCookie("i18n_redirected");
    setCookie("i18n_redirected", userLanguage);
    newPath = switchLocalePath(userLanguage);
  }

  if (newPath) {
    // Force a hard refresh when changing the language
    return navigateTo(newPath, {
      redirectCode: 301,
      external: true,
    });
  }
};

export { checkUserLanguage };

